import { nextMidnight } from 'components/CountdownTimer/CountdownTimer';

export const stringSeparatedWords = (separator, ...words) =>
  // remove all undefined words
  words
    .filter(Boolean)
    // combine all words using the seperator
    .join(separator);

/**
 * The timer on this page either counts down to the start of the class, or
 * midnight today, whichever comes first.
 */
export function getCountdownTime(classStartTime) {
  const nextMidnightTime = nextMidnight().valueOf();
  const countdownTo = nextMidnightTime > classStartTime ? classStartTime : nextMidnightTime;
  return countdownTo;
}
